import React, { useState } from 'react';
import { Button, Flex, FormControl, ModalBody, ModalCloseButton, ModalFooter, ModalHeader } from '@chakra-ui/react';
import DynamicFormField from '@components/DynamicFormField/DynamicFormField';
import ClientManager from '@components/FalconServiceDashboard/ClientManager';
import { OnHoldTransactionUpdateModal as formConfig } from '@components/FalconServiceDashboard/OnHoldTransactionUpdateModal/config';


const OnHoldTransactionUpdateModal = ({
  isLoading,
  onCancel,
  onSubmit,
  title = 'Update On Hold Txn Status',
  listOfAvailableClients = []
}) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value,
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit &&
      onSubmit({
        action: formData?.action,
        forceRoutingPartners: formData?.clientPriorityList
      });
  };

  const handleCancel = (e) => {
    e?.preventDefault();
    onCancel && onCancel();
  };

  return (
    <>
      <ModalHeader textAlign="center" py={0}>
        {title}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <FormControl as="form" onSubmit={handleSubmit}>
          <Flex
            w="100%"
            justifyContent="flex-start"
            height="100%"
            alignItems="center"
          >
          </Flex>
            {formConfig && formConfig?.map((field, index) => {
              if (field?.isEditable) {
                return (
                  <DynamicFormField
                    key={`${index}-${field.value}`}
                    fieldConfig={field}
                    data={formData}
                    handleChange={handleChange}
                  />
                );
              }
              return null;
            })}
             {formData?.action === 'QUEUE' && (
               <ClientManager
               setFormData={setFormData}
               listOfAvailableClients={listOfAvailableClients}
               />
              )
             }
            <ModalFooter justifyContent="center" gap={6}>
              <Button
                onClick={handleCancel}
                variant="ghost"
                colorScheme="white"
                bg="whiteAlpha.300"
                width="100%"
                size="md"
                fontSize="sm"
                mt={3}
                >
                Cancel
              </Button>
              <Button
                type="submit"
                colorScheme="brand"
                color="altGray.400"
                width="100%"
                size="md"
                fontSize="sm"
                mt={3}
                isLoading={isLoading}
                >
                Submit
              </Button>
            </ModalFooter>
          </FormControl>
        </ModalBody>
    </>
  );
};

export default OnHoldTransactionUpdateModal;